<template>
  <div :class="classModifiers">
    <div
      class="account-social-avatar__progress-container"
      v-if="showProgress"
      @click="onShowEditPopup"
    >
      <svg
        class="account-social-avatar__progress"
        :width="size"
        :height="size"
        viewBox="0 0 120 120"
      >
        <circle
          v-if="percentage < 100"
          class="account-social-avatar__progress-meter"
          cx="60"
          cy="60"
          :r="radius"
          :stroke-width="strokeWidth"
          :stroke="backgroundStrokeColor"
        ></circle>
        <circle
          class="account-social-avatar__progress-value"
          cx="60"
          cy="60"
          :r="radius"
          :stroke-width="strokeWidth"
          :style="styleModifiers"
        ></circle>
      </svg>
    </div>
    <div
      v-if="avatar"
      :class="imageClassModifiers"
      :style="imageStyleModifiers"
      @click="onShowEditPopup"
    ></div>
    <div v-if="showNotificationsCount" class="account-social-avatar__notifications-count">
      {{ notificationsCount }}
    </div>
    <div :class="labelClassModifiers" v-if="hasLabel">
      <slot name="label"> </slot>
      <slot></slot>
    </div>
    <span class="account-social-avatar__edit-photo" v-if="isEditEnabled"></span>
  </div>
</template>

<script src="./account-social-avatar.js"></script>
<style src="./account-social-avatar.scss" lang="scss"></style>
